

import React, { memo } from 'react';
import cn from 'classnames';
import '../styles/toggle-view-button.scss';
import { TextButton } from '../../TextButton';

export const DEFAULT_VIEW_TEXT = 'More...';
export const DEFAULT_HIDE_TEXT = 'Hide';










const ToggleViewButton = ({
  viewText = DEFAULT_VIEW_TEXT,
  hideText = DEFAULT_HIDE_TEXT,
  isExpanded,
  className,
  isDisabled,
  onClick
}) => {
  const content = isExpanded ? hideText : viewText;

  return (
    <TextButton
      className={cn('toggle-view-button', { 'toggle-view-button--expanded': isExpanded }, className)}
      isDisabled={isDisabled}
      onClick={onClick}>

      {content}
    </TextButton>);

};

export default memo(ToggleViewButton);